// // // import React from 'react';
// // // import { Button } from './ui/button';
// // // import { Check } from 'lucide-react';
// // // import { pricing } from '../mockData';

// // // const Pricing = () => {
// // //   return (
// // //     <section id="pricing" className="py-28 px-6 bg-gradient-to-b from-gray-50 to-white">
// // //       <div className="max-w-7xl mx-auto">
// // //         <div className="text-center mb-20">
// // //           <p className="text-brand-blue-600 text-sm font-bold mb-6 tracking-wide uppercase">{pricing.badge}</p>
// // //           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">{pricing.title}</h2>
// // //           <p className="text-xl text-gray-600 max-w-3xl mx-auto">{pricing.subtitle}</p>
// // //         </div>

// // //         <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
// // //           {pricing.plans.map((plan, index) => (
// // //             <div 
// // //               key={index} 
// // //               className={`relative bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${plan.popular ? 'ring-4 ring-brand-green-500 md:scale-105' : 'ring-1 ring-gray-200'}`}
// // //             >
// // //               {plan.popular && (
// // //                 <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-brand-green-500 to-brand-green-600 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
// // //                   Most Popular
// // //                 </div>
// // //               )}
              
// // //               <div className="mb-8">
// // //                 <div className="w-full h-36 rounded-2xl overflow-hidden mb-6 shadow-md">
// // //                   <img src={plan.image} alt={plan.name} className="w-full h-full object-cover" />
// // //                 </div>
// // //                 <h3 className="text-3xl font-bold mb-3">{plan.name}</h3>
// // //                 <div className="flex items-baseline mb-3">
// // //                   <span className="text-6xl font-bold">${plan.price}</span>
// // //                   <span className="text-gray-500 ml-2 text-xl">/{plan.period}</span>
// // //                 </div>
// // //                 <p className="text-gray-600 text-base leading-relaxed">{plan.description}</p>
// // //               </div>

// // //               <ul className="space-y-5 mb-10">
// // //                 {plan.features.map((feature, fIndex) => (
// // //                   <li key={fIndex} className="flex items-start space-x-3">
// // //                     <Check className="w-6 h-6 text-brand-green-600 flex-shrink-0 mt-0.5 font-bold" />
// // //                     <span className="text-gray-700 text-base">{feature}</span>
// // //                   </li>
// // //                 ))}
// // //               </ul>

// // //               <div className="space-y-3">
// // //                 <Button className={`w-full ${plan.popular ? 'bg-brand-green-600 hover:bg-brand-green-700' : 'bg-black hover:bg-gray-800'} text-white rounded-xl py-7 text-base font-semibold shadow-lg hover:shadow-xl transition-all`}>
// // //                   {plan.cta}
// // //                 </Button>
// // //                 <Button variant="outline" className="w-full border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 rounded-xl py-7 text-base font-semibold transition-all">
// // //                   {plan.secondaryCta}
// // //                 </Button>
// // //               </div>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default Pricing;

// // import React from 'react';
// // import { Button } from '@/components/ui/button';
// // import { Check } from 'lucide-react';
// // import { pricing } from '@/mockData';

// // const Pricing = () => {
// //   return (
// //     // DIUBAH: Dihapus 'bg-gradient-to-b from-gray-50 to-white'
// //     <section id="pricing" className="py-28 px-6">
// //       <div className="max-w-7xl mx-auto">
// //         <div className="text-center mb-20">
// //           {/* Badge ini sudah OK */}
// //           <p className="text-brand-blue-400 text-sm font-bold mb-6 tracking-wide uppercase">{pricing.badge}</p>
// //           {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
// //           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">{pricing.title}</h2>
// //           {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
// //           <p className="text-xl text-gray-300 max-w-3xl mx-auto">{pricing.subtitle}</p>
// //         </div>

// //         <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
// //           {pricing.plans.map((plan, index) => (
// //             <div 
// //               key={index} 
// //               // DIUBAH: 'bg-white' diubah menjadi 'bg-black/30 backdrop-blur-lg' dan 'border'
// //               className={`relative bg-black/30 backdrop-blur-lg rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${plan.popular ? 'ring-4 ring-brand-green-500 md:scale-105' : 'border border-gray-700/50'}`}
// //             >
// //               {plan.popular && (
// //                 <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-brand-green-500 to-brand-green-600 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
// //                   Most Popular
// //                 </div>
// //               )}
              
// //               <div className="mb-8">
// //                 <div className="w-full h-36 rounded-2xl overflow-hidden mb-6 shadow-md">
// //                   <img src={plan.image} alt={plan.name} className="w-full h-full object-cover" />
// //                 </div>
// //                 {/* DIUBAH: Teks judul plan diubah menjadi 'text-white' */}
// //                 <h3 className="text-3xl font-bold mb-3 text-white">{plan.name}</h3>
// //                 <div className="flex items-baseline mb-3">
// //                   {/* DIUBAH: Teks harga diubah menjadi 'text-white' */}
// //                   <span className="text-6xl font-bold text-white">${plan.price}</span>
// //                   {/* DIUBAH: Teks periode diubah menjadi 'text-gray-400' */}
// //                   <span className="text-gray-400 ml-2 text-xl">/{plan.period}</span>
// //                 </div>
// //                 {/* DIUBAH: Teks deskripsi diubah menjadi 'text-gray-300' */}
// //                 <p className="text-gray-300 text-base leading-relaxed">{plan.description}</p>
// //               </div>

// //               <ul className="space-y-5 mb-10">
// //                 {plan.features.map((feature, fIndex) => (
// //                   <li key={fIndex} className="flex items-start space-x-3">
// //                     <Check className="w-6 h-6 text-brand-green-500 flex-shrink-0 mt-0.5 font-bold" />
// //                     {/* DIUBAH: Teks fitur diubah menjadi 'text-gray-200' */}
// //                     <span className="text-gray-200 text-base">{feature}</span>
// //                   </li>
// //                 ))}
// //               </ul>

// //               <div className="space-y-3">
// //                 <Button className={`w-full ${plan.popular ? 'bg-brand-green-600 hover:bg-brand-green-700' : 'bg-white text-black hover:bg-gray-200'} rounded-xl py-7 text-base font-semibold shadow-lg hover:shadow-xl transition-all`}>
// //                   {plan.cta}
// //                 </Button>
// //                 {/* DIUBAH: Tombol sekunder disesuaikan untuk dark mode */}
// //                 <Button variant="outline" className="w-full border-2 border-gray-600 text-white hover:bg-gray-800/50 hover:border-gray-500 rounded-xl py-7 text-base font-semibold transition-all">
// //                   {plan.secondaryCta}
// //                 </Button>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Pricing;

// import React from 'react';
// import { Button } from '@/components/ui/button';
// import { Check } from 'lucide-react';
// import { pricing } from '@/mockData';

// const Pricing = () => {
//   // --- TAMBAHAN LOGIKA ---
//   // Hitung jumlah plans
//   const numPlans = pricing.plans.length;

//   // Tentukan kelas grid desktop berdasarkan jumlah plans
//   let desktopCols = 'md:grid-cols-3'; // Default untuk 3 atau lebih
//   let maxWidth = 'max-w-6xl';     // Default untuk 3 atau lebih

//   if (numPlans === 1) {
//     desktopCols = 'md:grid-cols-1';
//     maxWidth = 'max-w-md'; // Batasi lebar untuk 1 card agar tidak terlalu besar
//   } else if (numPlans === 2) {
//     desktopCols = 'md:grid-cols-2';
//     maxWidth = 'max-w-3xl'; // Batasi lebar untuk 2 card
//   }
//   // Jika 3 atau lebih, maka akan menggunakan default (md:grid-cols-3 dan max-w-6xl)
//   // --- AKHIR TAMBAHAN LOGIKA ---

//   return (
//     // DIUBAH: Dihapus 'bg-gradient-to-b from-gray-50 to-white'
//     <section id="pricing" className="py-28 px-6">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-20">
//           {/* Badge ini sudah OK */}
//           <p className="text-brand-blue-400 text-sm font-bold mb-6 tracking-wide uppercase">{pricing.badge}</p>
//           {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
//           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">{pricing.title}</h2>
//           {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
//           <p className="text-xl text-gray-300 max-w-3xl mx-auto">{pricing.subtitle}</p>
//         </div>

//         {/* --- PERUBAHAN DI SINI --- */}
//         {/* Kelas 'md:grid-cols-3' dan 'max-w-6xl' sekarang dinamis */}
//         <div className={`grid grid-cols-1 ${desktopCols} gap-8 ${maxWidth} mx-auto`}>
//           {pricing.plans.map((plan, index) => (
//             <div 
//               key={index} 
//               // DIUBAH: 'bg-white' diubah menjadi 'bg-black/30 backdrop-blur-lg' dan 'border'
//               className={`relative bg-black/30 backdrop-blur-lg rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${plan.popular ? 'ring-4 ring-brand-green-500 md:scale-105' : 'border border-gray-700/50'}`}
//             >
//               {plan.popular && (
//                 <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-brand-green-500 to-brand-green-600 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
//                   Most Popular
//                 </div>
//               )}
              
//               <div className="mb-8">
//                 <div className="w-full h-36 rounded-2xl overflow-hidden mb-6 shadow-md">
//                   <img src={plan.image} alt={plan.name} className="w-full h-full object-cover" />
//                 </div>
//                 {/* DIUBAH: Teks judul plan diubah menjadi 'text-white' */}
//                 <h3 className="text-3xl font-bold mb-3 text-white">{plan.name}</h3>
//                 <div className="flex items-baseline mb-3">
//                   {/* DIUBAH: Teks harga diubah menjadi 'text-white' */}
//                   <span className="text-6xl font-bold text-white">${plan.price}</span>
//                   {/* DIUBAH: Teks periode diubah menjadi 'text-gray-400' */}
//                   <span className="text-gray-400 ml-2 text-xl">/{plan.period}</span>
//                 </div>
//                 {/* DIUBAH: Teks deskripsi diubah menjadi 'text-gray-300' */}
//                 <p className="text-gray-300 text-base leading-relaxed">{plan.description}</p>
//               </div>

//               <ul className="space-y-5 mb-10">
//                 {plan.features.map((feature, fIndex) => (
//                   <li key={fIndex} className="flex items-start space-x-3">
//                     <Check className="w-6 h-6 text-brand-green-500 flex-shrink-0 mt-0.5 font-bold" />
//                     {/* DIUBAH: Teks fitur diubah menjadi 'text-gray-200' */}
//                     <span className="text-gray-200 text-base">{feature}</span>
//                   </li>
//                 ))}
//               </ul>

//               <div className="space-y-3">
//                 <Button className={`w-full ${plan.popular ? 'bg-brand-green-600 hover:bg-brand-green-700' : 'bg-white text-black hover:bg-gray-200'} rounded-xl py-7 text-base font-semibold shadow-lg hover:shadow-xl transition-all`}>
//                   {plan.cta}
//                 </Button>
//                 {/* DIUBAH: Tombol sekunder disesuaikan untuk dark mode */}
//                 <Button variant="outline" className="w-full border-2 border-gray-600 text-white hover:bg-gray-800/50 hover:border-gray-500 rounded-xl py-7 text-base font-semibold transition-all">
//                   {plan.secondaryCta}
//                 </Button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Pricing;

import React from 'react';
import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';
// DIUBAH: Path impor diperbaiki menggunakan alias
import { pricing } from '@/mockData.js';

const Pricing = () => {
  // --- TAMBAHAN LOGIKA ---
  // Hitung jumlah plans
  const numPlans = pricing.plans.length;

  // Tentukan kelas grid desktop berdasarkan jumlah plans
  let desktopCols = 'md:grid-cols-3'; // Default untuk 3 atau lebih
  let maxWidth = 'max-w-6xl';     // Default untuk 3 atau lebih

  if (numPlans === 1) {
    desktopCols = 'md:grid-cols-1';
    maxWidth = 'max-w-md'; // Batasi lebar untuk 1 card agar tidak terlalu besar
  } else if (numPlans === 2) {
    desktopCols = 'md:grid-cols-2';
    maxWidth = 'max-w-3xl'; // Batasi lebar untuk 2 card
  }
  // Jika 3 atau lebih, maka akan menggunakan default (md:grid-cols-3 dan max-w-6xl)
  // --- AKHIR TAMBAHAN LOGIKA ---

  return (
    // DIUBAH: Dihapus 'bg-gradient-to-b from-gray-50 to-white'
    <section id="pricing" className="py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          {/* Badge ini sudah OK */}
          <p className="text-brand-blue-400 text-sm font-bold mb-6 tracking-wide uppercase">{pricing.badge}</p>
          {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
          <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">{pricing.title}</h2>
          {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">{pricing.subtitle}</p>
        </div>

        {/* --- PERUBAHAN DI SINI --- */}
        {/* Kelas 'md:grid-cols-3' dan 'max-w-6xl' sekarang dinamis */}
        <div className={`grid grid-cols-1 ${desktopCols} gap-8 ${maxWidth} mx-auto`}>
          {pricing.plans.map((plan, index) => {
            
            // --- LOGIKA LINK DINAMIS DITAMBAHKAN ---
            let ctaLink = null;
            let secondaryCtaLink = null;
            // Gunakan optional chaining (?) dan nullish coalescing (??) untuk keamanan
            const normalizedCta = plan.cta?.trim() ?? '';
            const normalizedSecondaryCta = plan.secondaryCta?.trim() ?? '';
      
            // Cek untuk tombol "Contact Us"
            if (normalizedCta === 'Contact Us') {
              const emailTo = 'rafi@mpstore.co.id';
              const emailSubject = '[MPSTore Business Solution] Inquiry about Enterprise Package';
              ctaLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${emailTo}&su=${encodeURIComponent(emailSubject)}`;
              // ctaLink = 'https://mail.google.com/mail/?view=cm&fs=1&to=rafi@mpstore.co.id';
            }
            
            // Cek untuk tombol "Chat for details"
            if (normalizedSecondaryCta === 'Chat for details') {
              // Format nomor WA: hilangkan +, spasi, dan -
              const waNumber = "6282334536656";
              const waMessage = "Hello, I'm interested in the MPStore Business Solution Enterprise package. Can I get more information?";
              secondaryCtaLink = `https://wa.me/${waNumber}?text=${encodeURIComponent(waMessage)}`;
            }
            // --- AKHIR LOGIKA LINK ---

            return (
              <div 
                key={index} 
                // DIUBAH: 'bg-white' diubah menjadi 'bg-black/30 backdrop-blur-lg' dan 'border'
                className={`relative bg-black/30 backdrop-blur-lg rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${plan.popular ? 'ring-4 ring-brand-green-500 md:scale-105' : 'border border-gray-700/50'}`}
              >
                {plan.popular && (
                  <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-brand-green-500 to-brand-green-600 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                    Most Popular
                  </div>
                )}
                
                <div className="mb-8">
                  <div className="w-full h-36 rounded-2xl overflow-hidden mb-6 shadow-md">
                    <img src={plan.image} alt={plan.name} className="w-full h-full object-cover" />
                  </div>
                  {/* DIUBAH: Teks judul plan diubah menjadi 'text-white' */}
                  <h3 className="text-3xl font-bold mb-3 text-white">{plan.name}</h3>
                  <div className="flex items-baseline mb-3">
                    {/* DIUBAH: Teks harga diubah menjadi 'text-white' */}
                    <span className="text-6xl font-bold text-white">${plan.price}</span>
                    {/* DIUBAH: Teks periode diubah menjadi 'text-gray-400' */}
                    {/* Tambahkan cek agar tidak render "/null" jika period null */}
                    {plan.period && (
                      <span className="text-gray-400 ml-2 text-xl">/{plan.period}</span>
                    )}
                  </div>
                  {/* DIUBAH: Teks deskripsi diubah menjadi 'text-gray-300' */}
                  <p className="text-gray-300 text-base leading-relaxed">{plan.description}</p>
                </div>

                <ul className="space-y-5 mb-10">
                  {plan.features.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-start space-x-3">
                      <Check className="w-6 h-6 text-brand-green-500 flex-shrink-0 mt-0.5 font-bold" />
                      {/* DIUBAH: Teks fitur diubah menjadi 'text-gray-200' */}
                      <span className="text-gray-200 text-base">{feature}</span>
                    </li>
                  ))}
                </ul>

                <div className="space-y-3">
                  {/* --- TOMBOL 1 (CTA) DIUBAH --- */}
                  <Button 
                    asChild={!!ctaLink} // Set asChild ke true jika ctaLink ada
                    className={`w-full ${plan.popular ? 'bg-brand-green-600 hover:bg-brand-green-700' : 'bg-white text-black hover:bg-gray-200'} rounded-xl py-7 text-base font-semibold shadow-lg hover:shadow-xl transition-all`}
                  >
                    {ctaLink ? (
                      <a href={ctaLink} target="_blank" rel="noopener noreferrer">
                        {plan.cta}
                      </a>
                    ) : (
                      <>{plan.cta}</> // Tampilkan sebagai teks biasa jika tidak ada link
                    )}
                  </Button>
                  
                  {/* --- TOMBOL 2 (SECONDARY CTA) DIUBAH --- */}
                  <Button 
                    asChild={!!secondaryCtaLink} // Set asChild ke true jika secondaryCtaLink ada
                    variant="outline" 
                    className="w-full border-2 border-gray-600 text-white hover:bg-gray-800/50 hover:border-gray-500 rounded-xl py-7 text-base font-semibold transition-all"
                  >
                    {secondaryCtaLink ? (
                      <a href={secondaryCtaLink} target="_blank" rel="noopener noreferrer">
                        {plan.secondaryCta}
                      </a>
                    ) : (
                      <>{plan.secondaryCta}</> // Tampilkan sebagai teks biasa jika tidak ada link
                    )}
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Pricing;